var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudioFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "audio_document",
    "data-name": "audio document",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.223,
    height: 30.223,
    viewBox: "0 0 30.223 30.223",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2369",
    "data-name": "Trac\\xE9 2369",
    d: "M28.386,7.052h1.007V6.636l-.3-.3ZM22.341,1.007,23.053.3l-.3-.3h-.416ZM16.3,9.067l.806-.6a1.006,1.006,0,0,0-1.813.6Zm.6.806.806-.6Zm9.47,18.335H6.222v2.015H26.371ZM5.215,27.2V3.022H3.2V27.2ZM27.378,7.052V27.2h2.015V7.052ZM6.222,2.015H22.341V0H6.222Zm15.407-.3,6.045,6.045L29.1,6.34,23.053.3ZM6.222,28.208A1.01,1.01,0,0,1,5.215,27.2H3.2a3.023,3.023,0,0,0,3.022,3.022Zm20.148,2.015A3.023,3.023,0,0,0,29.393,27.2H27.378a1.01,1.01,0,0,1-1.007,1.007ZM5.215,3.022A1.01,1.01,0,0,1,6.222,2.015V0A3.023,3.023,0,0,0,3.2,3.022Zm8.059,19.141a2.013,2.013,0,0,1-2.015-2.015H9.245a4.033,4.033,0,0,0,4.03,4.03Zm2.015-2.015a2.013,2.013,0,0,1-2.015,2.015v2.015a4.033,4.033,0,0,0,4.03-4.03Zm-2.015-2.015a2.013,2.013,0,0,1,2.015,2.015H17.3a4.033,4.033,0,0,0-4.03-4.03Zm0-2.015a4.033,4.033,0,0,0-4.03,4.03h2.015a2.013,2.013,0,0,1,2.015-2.015ZM15.289,13.1v7.052H17.3V13.1ZM17.3,14.1V9.067H15.289V14.1ZM15.491,9.671l.6.806,1.612-1.209-.6-.806Zm.6.806A9.062,9.062,0,0,0,23.348,14.1V12.089a7.052,7.052,0,0,1-5.642-2.821Z",
    transform: "translate(-1.185)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2370",
    "data-name": "Trac\\xE9 2370",
    d: "M0,0H30.223V30.223H0Z",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioFileIcon);
export default __webpack_public_path__ + "static/media/audioFileIcon.a851c162e34ad129655bfe162e63ebda.svg";
export { ForwardRef as ReactComponent };